
import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle
} from '@/components/ui/dialog';
import VoiceAssistantConfig from '@/components/VoiceAssistantConfig';

interface InstallationVoiceConfigModalProps {
  isOpen: boolean;
  onClose: () => void;
  installationKey?: string;
  domain?: string;
}

const InstallationVoiceConfigModal = ({
  isOpen,
  onClose,
  installationKey,
  domain
}: InstallationVoiceConfigModalProps) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Voice Assistant Configuration</DialogTitle>
          <DialogDescription>
            Configure voice commands and navigation for {domain}
          </DialogDescription>
        </DialogHeader>
        
        <div className="mt-4">
          <VoiceAssistantConfig installationKey={installationKey} />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default InstallationVoiceConfigModal;
